import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Spinner,
} from "reactstrap";
import { FiMail, FiLock, FiEye, FiEyeOff } from "react-icons/fi";
import { FaBriefcase } from "react-icons/fa";
import useAuth from "../../hooks/useAuth";
import { login } from "../../services/authService";
import "./AdminLogin.css";

function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
const [error, setError] = useState("");
  const navigate = useNavigate();
  const { setIsAuth } = useAuth();


  const handleLogin = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    const data = await login(email, password);
    console.log("Login response:", data);
setError("");
    const { token, user } = data;

    const userInfo = {
      id: user.id,
      name: user.name,
      email: user.email,
      role: user.role,
      token: token,
    };

    localStorage.setItem("user", JSON.stringify(userInfo));

    setIsAuth(true);

    // Since only admin role exists
    navigate("/admin/dashboard");

  } catch (err) {
    setError(err.message || "Invalid email or password");
    console.error(err.message);
  } finally {
    setLoading(false);
  }
};



  return (
  <div className="admin-login-fullscreen min-vh-100 d-flex">
      {/* Left decorative panel - visible on lg+ screens */}
      <div className="admin-login-left-panel d-none d-lg-flex position-relative align-items-center justify-content-center">
        {/* Background blobs */}
        <div className="admin-login-blobs position-absolute inset-0 opacity-10">
          <div className="admin-login-blob-top-left" />
          <div className="admin-login-blob-bottom-right" />
        </div>

        <div className="admin-login-brand-content position-relative text-center px-5">
          <div className="admin-login-icon-wrapper d-inline-flex align-items-center justify-content-center mb-4">
            <FaBriefcase className="admin-login-briefcase-icon" />
          </div>

          <h1 className="admin-login-title mb-3">HR Recruit Pro</h1>

          <p className="admin-login-subtitle mb-5">
            Streamline your hiring process with powerful recruitment management tools.
          </p>

          <div className="admin-login-stats d-flex justify-content-center gap-5">
            <div className="admin-login-stat-item text-center">
              <div className="admin-login-stat-number">500+</div>
              <div className="admin-login-stat-label">Jobs Posted</div>
            </div>
            <div className="admin-login-stat-item text-center">
              <div className="admin-login-stat-number">2.4K</div>
              <div className="admin-login-stat-label">Applicants</div>
            </div>
            <div className="admin-login-stat-item text-center">
              <div className="admin-login-stat-number">98%</div>
              <div className="admin-login-stat-label">Satisfaction</div>
            </div>
          </div>
        </div>
      </div>

      {/* Right side - login form */}
      <div className="admin-login-right-panel flex-grow-1 d-flex align-items-center justify-content-center p-4 p-md-5">
        <div className="admin-login-form-wrapper w-100" style={{ maxWidth: "420px" }}>
          {/* Mobile logo */}
          <div className="d-flex d-lg-none align-items-center gap-3 mb-5">
            <div className="admin-login-mobile-logo d-flex align-items-center justify-content-center">
              <FaBriefcase size={22} />
            </div>
            <span className="admin-login-mobile-title fw-bold fs-4">HR Recruit Pro</span>
          </div>

          <h2 className="admin-login-form-title mb-2 text-center">Welcome back</h2>
          <p className="admin-login-form-subtitle mb-4 text-center">
            Sign in to your admin panel
          </p>

          {error && (
            <div className="admin-login-error-alert alert alert-danger mb-4">
              {error}
            </div>
          )}

          <Form onSubmit={handleLogin}>
            <FormGroup className="admin-login-form-group mb-4">
              <Label className="admin-login-label">Email</Label>
              <div className="admin-login-input-wrapper position-relative">
                <FiMail className="admin-login-input-icon" />
                <Input
                  type="email"
                  placeholder="admin@company.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="admin-login-input ps-5"
                  required
                  disabled={loading}
                />
              </div>
            </FormGroup>

            <FormGroup className="admin-login-form-group mb-4">
              <Label className="admin-login-label">Password</Label>
              <div className="admin-login-input-wrapper position-relative">
                <FiLock className="admin-login-input-icon" />
                <Input
                  type={showPassword ? "text" : "password"}
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="admin-login-input ps-5 pe-5"
                  required
                  disabled={loading}
                />
                <button
                  type="button"
                  className="admin-login-password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                  disabled={loading}
                >
                  {showPassword ? <FiEyeOff /> : <FiEye />}
                </button>
              </div>
            </FormGroup>

            <Button
              type="submit"
              color="primary"
              block
              className="admin-login-submit-btn"
              disabled={loading}
            >
              {loading ? (
                <>
                  <Spinner size="sm" className="me-2" />
                  Signing in...
                </>
              ) : (
                "Sign In"
              )}
            </Button>
          </Form>

          <p className="admin-login-footer-text text-center mt-5 small text-muted">
            Protected admin access. Contact IT for support.
          </p>
        </div>
      </div>
    </div>
  );
}

export default AdminLogin;